export default class OutcomeConversionService {
  /**
   * outcome converter in different formats
   * @param decimalOutcome
   * @return converted outcome as string
   */
  static outcomeConverter(decimalOutcome, format) {
    if (decimalOutcome === null || Number.parseFloat(decimalOutcome) === 0 || Number.parseFloat(decimalOutcome) === 1) {
      return '--';
    }
    let convertedOdd = decimalOutcome;

    let userSelectedFormat = format || localStorage.getItem('oddFormat');
    // eslint-disable-next-line no-undef
    let formatting = userSelectedFormat || APP_SETTINGS.formatting.defaultOutcomeType;
    switch (formatting) {
      case 'fractional':
        convertedOdd = this.toFractional(decimalOutcome);
        break;
      case 'american':
        convertedOdd = this.toAmerican(decimalOutcome);
        break;
      default:
        break;
    }
    return convertedOdd;
  }

  /**
   * Converter to american outcomes
   * @param decimalOutcome input decimal outcome
   * @return converted outcome as string as american outcome
   */
  static toAmerican(decimalOutcome) {
    let decimal = parseFloat(decimalOutcome);
    let convertedOdd = 0;
    if (isNaN(decimal) || decimal <= 1) {
      return '--';
    }

    if (decimal < 2) {
      convertedOdd = -100 / (decimal - 1);
    } else {
      convertedOdd = (decimal - 1) * 100;
    }
    convertedOdd = (convertedOdd > 0 ? '+' : '') + Math.round(Math.round(convertedOdd * 100) / 100);

    return convertedOdd;
  }

  /**
   * Converter to fractinal outcomes
   * @param decimalOutcome input decimal outcome
   * @return converted outcome as string as fractional outcome
   */
  static toFractional(decimalOutcome) {
    let decimal = parseFloat(decimalOutcome);
    if (isNaN(decimal) || decimal <= 1) {
      return '--';
    }
    decimal -= 1;
    let bestFrac = `${Math.round(decimal)}/1`;
    let bestFracVal = Math.round(decimal);
    let myBestErr = Math.abs(bestFracVal - decimal);
    for (let i = 2; i <= 200; i += 1) {
      let myFracVal = Math.round(decimal * i) / i;
      let myErr = Math.abs(myFracVal - decimal);
      if (myErr < myBestErr) {
        bestFrac = `${Math.round(decimal * i)}/${i}`;
        bestFracVal = myFracVal;
        if (myErr === 0) break;
        myBestErr = myErr;
      }
    }
    return bestFrac;
  }
}
